import Vue from 'vue'
import axios from 'axios/index'

// state
export const state = {
  isFriendLoading: false,
  friends: {},
}

// getters
export const getters = {
  getFriendById: ({ friends }) => ({ friendId }) => friends[friendId] || null,
}
// mutations
export const mutations = {
  fetchFriendStart(state) {
    state.isFriendLoading = true
  },
  fetchFriendSuccess(state, { friend, userId }) {
    state.isFriendLoading = false
    Vue.set(state.friends, userId, friend)
  },
  fetchFriendFailed(state) {
    state.isFriendLoading = false
  },
}
// actions
export const actions = {
  async fetchFriend({ commit, getters }, { userId }) {
    const cachedFriend = getters.getFriendById({ friendId: userId })
    if (cachedFriend) {
      return cachedFriend
    }
    try {
      commit('fetchFriendStart')
      const friend = await axios.get(`clan/friend/${userId}`)
      commit('fetchFriendSuccess', {
        friend,
        userId,
      })
    } catch (err) {
      commit('fetchFriendFailed')
    }
    return false
  },
}
